/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Claims_Step_6Inputs */

const en_claims_step_6 = /** @type {(inputs: Claims_Step_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hit ‘Submit Claim’ button.`)
};

const fr_claims_step_6 = /** @type {(inputs: Claims_Step_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cliquez sur le bouton 'Soumettre la réclamation'.`)
};

/**
* | output |
* | --- |
* | "Hit ‘Submit Claim’ button." |
*
* @param {Claims_Step_6Inputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const claims_step_6 = /** @type {((inputs?: Claims_Step_6Inputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Claims_Step_6Inputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_claims_step_6(inputs)
	return fr_claims_step_6(inputs)
});